import React from "react";
import Context from "./context.js";
import axios from "axios";
import Component from "@reactions/component";
import host from "./host";
import Cookies from "universal-cookie";
import { Pane, Spinner, Dialog, Textarea, Label, SideSheet, Button, SelectField, FormField, TextInput, Autocomplete } from 'evergreen-ui'
import { FaArrowCircleLeft, FaPhone, FaPrint, FaEdit, FaClock, FaMapMarkerAlt, FaUser, FaStore, FaDollarSign, FaBoxes, FaCheckCircle, FaExclamationTriangle, FaTimes, FaPlus, FaMinus, FaSearch } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { FcMissedCall, FcApproval, FcCancel, FcPaid, FcInfo } from "react-icons/fc";
import * as moment from "moment-timezone";
import { Link } from 'react-router-dom';

const cookies = new Cookies();

class SingleConfirmOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: null,
            loading: true,
            notes: '',
            // Edit state
            isEditSheetOpen: false,
            editType: '', // 'address' or 'items'
            editData: {
                government: '',
                city: '',
                selectedItems: {},
                price: 0, // إضافة السعر
                is_upsells: false // إضافة متغير المبيعات الأعلى
            },
            // Loading states for buttons
            isUpdatingAddress: false,
            isUpdatingItems: false,
            // Available options (these would come from API)
            governments: [
                'بغداد', 'البصرة', 'الموصل', 'أربيل', 'النجف', 'كربلاء',
                'الأنبار', 'دهوك', 'واسط', 'ميسان', 'ذي قار', 'بابل',
                'كركوك', 'ديالى', 'المثنى', 'القادسية', 'صلاح الدين', 'السليمانية'
            ],
            // Items state for autocomplete
            itemSearchValue: '',
            filteredItems: [],
            selectedItemsForEdit: {},
            // Sample items - replace with API call
            availableItems: []
        };
    }

    componentDidMount() {

        this.fetchOrder();
        this.fetchItems();

        this.setState({ filteredItems: this.state.availableItems });
    }

    fetchOrder() {

        var url = window.location;
        let params = new URLSearchParams(url.search);
        let id = params.get('id')


        var header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        axios.get(host + `users/all/ordrers/my?id=${id}`, { headers: header })
            .then(res => {

                const order = res.data.data.orders[0];
                this.setState({
                    order: order,
                    loading: false,
                    editData: {
                        government: order.government,
                        city: order.city,
                        selectedItems: this.convertOrderItemsToEditFormat(order.ordersFormItems),
                        price: '', // جعل السعر فارغ بدلاً من القيمة الحالية
                        is_upsells: order.is_upsells == 1 // تحديد الـ checkbox بناءً على قيمة الـ API
                    }
                });
            })
            .catch(error => {
                console.log(error);
                this.setState({ loading: false });
            });
    }
    fetchItems() {
        var header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        axios.get(host + `users/all/items/`, { headers: header })
            .then((response) => {

                this.setState({ availableItems: response.data.data.data })
            })
    }

    convertOrderItemsToEditFormat(orderItems) {
        const selectedItems = {};
        if (orderItems) {
            orderItems.forEach(item => {
                selectedItems[item.components.id || item.components.name] = parseInt(item.count);
            });
        }
        return selectedItems;
    }

    // دالة للتحقق من إمكانية التعديل
    canEdit() {
        const { order } = this.state;
        return order && (order.status === -1 || order.status === -2);
    }

    openEditSheet = (type) => {
        // التحقق من إمكانية التعديل
        if (!this.canEdit()) {
            return;
        }

        let currentSelectedItems = {};

        if (type === 'items' && this.state.order && this.state.order.ordersFormItems) {
            // Convert current order items to selectedItemsForEdit format
            this.state.order.ordersFormItems.forEach(item => {
                const itemId = item.components.id || item.components.name;
                currentSelectedItems[itemId] = parseInt(item.count);
            });
        }

        this.setState({
            isEditSheetOpen: true,
            editType: type,
            selectedItemsForEdit: type === 'items' ? currentSelectedItems : {},
            itemSearchValue: '',
            // تحديث السعر عند فتح نافذة تعديل المواد - يبقى فارغ
            editData: {
                ...this.state.editData,
                price: type === 'items' ? '' : this.state.editData.price,
                is_upsells: type === 'items' ? (this.state.order && this.state.order.is_upsells == 1) : this.state.editData.is_upsells // استخدام القيمة من الـ API للمواد
            }
        });
    }

    closeEditSheet = () => {
        this.setState({
            isEditSheetOpen: false,
            editType: '',
            selectedItemsForEdit: {},
            itemSearchValue: ''
        });
    }

    updateEditData = (field, value) => {
        this.setState(prevState => ({
            editData: {
                ...prevState.editData,
                [field]: value
            }
        }));
    }

    handleItemSearch = (value) => {
        this.setState({ itemSearchValue: value });
        const filtered = this.state.availableItems.filter(item =>
            item.label.toLowerCase().includes(value.toLowerCase())
        );
        this.setState({ filteredItems: filtered });
    }

    addSelectedItem = (item) => {
        if (item.count > 0) {
            this.setState(prevState => ({
                selectedItemsForEdit: {
                    ...prevState.selectedItemsForEdit,
                    [item.id]: 1
                },
                itemSearchValue: ''
            }));
        }
    }

    toggleItemSelection = (item) => {
        const isCurrentlySelected = this.state.selectedItemsForEdit[item.id] > 0;

        if (isCurrentlySelected) {
            // Remove item
            const newSelected = { ...this.state.selectedItemsForEdit };
            delete newSelected[item.id];
            this.setState({ selectedItemsForEdit: newSelected });
        } else {
            // Add item with quantity 1
            this.setState(prevState => ({
                selectedItemsForEdit: {
                    ...prevState.selectedItemsForEdit,
                    [item.id]: 1
                }
            }));
        }
    }

    // Helper function to find item by label or id
    findItemByIdOrName = (identifier) => {
        return this.state.availableItems.find(item =>
            item.id.toString() === identifier.toString() ||
            item.label === identifier
        );
    }

    updateItemQuantity = (itemId, quantity) => {
        // Find the item to check stock limits
        let item = this.findItemByIdOrName(itemId);

        // If not found in available items, assume it's from the original order (no stock limit)
        if (!item) {
            item = { count: 999 }; // No limit for original order items
        }

        if (quantity <= 0) {
            const newSelected = { ...this.state.selectedItemsForEdit };
            delete newSelected[itemId];
            this.setState({ selectedItemsForEdit: newSelected });
        } else {
            // Allow updating quantity for all items regardless of stock count
            this.setState(prevState => ({
                selectedItemsForEdit: {
                    ...prevState.selectedItemsForEdit,
                    [itemId]: quantity
                }
            }));
        }
    }

    saveEditChanges = () => {
        const { editType, editData, selectedItemsForEdit, order } = this.state;

        if (editType === 'address') {
            this.updateOrderAddress(order.id, editData.government, editData.city);
        } else if (editType === 'items') {
            // التحقق من السعر قبل الحفظ
            if (!editData.price || editData.price <= 0) {
                window.alert('يرجى إدخال السعر الإجمالي');
                return;
            }
            this.updateOrderItems(order.id, selectedItemsForEdit, editData.price, editData.is_upsells);
        }

        // لا نغلق الـ Side Sheet هنا - سيتم إغلاقه في callback النجاح
    }

    updateOrderAddress = (orderId, government, city) => {
        this.setState({ isUpdatingAddress: true });
        const header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        axios.post(host + 'users/web/orders/update-address', {
            id: orderId,
            government: government,
            city: city
        }, { headers: header })
            .then(response => {
                window.alert('تم تحديث العنوان بنجاح');
                this.fetchOrder(orderId);
                this.setState({ isUpdatingAddress: false });
                this.closeEditSheet(); // إغلاق الـ Side Sheet بعد النجاح
            })
            .catch(error => {
                window.alert('حدث خطأ في تحديث العنوان');
                console.error(error);
                this.setState({ isUpdatingAddress: false });
                // لا نغلق الـ Side Sheet في حالة الخطأ
            });
    }

    updateOrderItems = (orderId, selectedItems, price, is_upsells) => {
        this.setState({ isUpdatingItems: true });
        const header = { "Content-Type": "application/json", Authorization: cookies.get("token") };

        const items = Object.entries(selectedItems)
            .filter(([itemId, quantity]) => quantity > 0)
            .map(([itemId, quantity]) => ({
                itemId: itemId,
                quantity: quantity
            }));

        console.log(items);

        axios.post(host + 'users/web/orders/update-items', {
            id: orderId,
            items: items,
            price: price, // إضافة السعر للطلب
            is_upsells: is_upsells // إضافة متغير المبيعات الأعلى
        }, { headers: header })
            .then(response => {
                window.alert('تم تحديث المواد والسعر بنجاح');
                this.fetchOrder(orderId);
                this.setState({ isUpdatingItems: false });
                this.closeEditSheet(); // إغلاق الـ Side Sheet بعد النجاح
            })
            .catch(error => {
                window.alert('حدث خطأ في تحديث المواد');
                console.error(error);
                this.setState({ isUpdatingItems: false });
                // لا نغلق الـ Side Sheet في حالة الخطأ
            });
    }

    confirmOrder(id, name, notes) {
        axios({
            method: 'post',
            url: host + 'users/web/orders/confirm',
            headers: { 'Authorization': cookies.get("token") },
            data: {
                status: 1,
                notes: notes,
                id: id,
            }
        }).then((response) => {
            window.alert(`تم تأكيد الطلب رقم ${id} الطلب بأسم ${name}`);
            this.fetchOrder(id);
        }).catch((error) => {
            window.location.href = '/Error';
        });
    }

    setNoAnswer(id, name) {
        axios({
            method: 'post',
            url: host + 'users/web/orders/confirm',
            headers: { 'Authorization': cookies.get("token") },
            data: {
                status: 3,
                id: id,
            }
        }).then((response) => {
            window.alert(`تم تحديد كـ لايرد الطلب رقم ${id} الطلب بأسم ${name}`);
            this.fetchOrder(id);
        }).catch((error) => {
            window.location.href = '/Error';
        });
    }

    deleteOrder(id, name, notes) {
        axios({
            method: 'post',
            url: host + 'users/web/orders/confirm',
            headers: { 'Authorization': cookies.get("token") },
            data: {
                status: 2,
                reject: notes,
                id: id,
            }
        }).then((response) => {
            window.alert(`تم الغاء الطلب رقم ${id} الطلب بأسم ${name}`);
            this.fetchOrder(id);
        }).catch((error) => {
            window.location.href = '/Error';
        });
    }

    click_log(id, type) {
        axios({
            method: 'post',
            url: host + 'users/web/click/log',
            headers: { 'Authorization': cookies.get("token") },
            data: {
                status: type,
                id: id,
            }
        }).then((response) => {
            // Success handling
        }).catch((error) => {
            window.location.href = '/Error';
        });
    }

    renderEditSideSheet() {
        const { isEditSheetOpen, editType, editData, governments, selectedItemsForEdit, itemSearchValue, filteredItems, isUpdatingAddress, isUpdatingItems } = this.state;

        if (!isEditSheetOpen) return null;

        const styles = {
            // Side Sheet Styles
            sideSheetContent: {
                padding: '15px',
                direction: 'rtl',
                height: '100%',
                overflow: 'auto'
            },
            sideSheetHeader: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                paddingBottom: '15px',
                borderBottom: '2px solid #e2e8f0'
            },
            sideSheetTitle: {
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#2d3748'
            },
            formSection: {
                background: '#f8fafc',
                borderRadius: '12px',
                padding: '15px',
                margin: '10px 0',
                border: '1px solid #e2e8f0'
            },
            formSectionTitle: {
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#2d3748',
                marginBottom: '15px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            },
            input: {
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '2px solid #e2e8f0',
                fontSize: '14px',
                boxSizing: 'border-box'
            },
            numberInput: {
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '2px solid #e2e8f0',
                fontSize: '14px',
                boxSizing: 'border-box',
                textAlign: 'center',
                fontWeight: 'bold'
            },
            select: {
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '2px solid #e2e8f0',
                fontSize: '14px',
                boxSizing: 'border-box'
            },
            searchContainer: {
                position: 'relative',
                marginBottom: '15px'
            },
            searchInput: {
                width: '100%',
                padding: '12px 40px 12px 12px',
                borderRadius: '8px',
                border: '2px solid #e2e8f0',
                fontSize: '14px',
                boxSizing: 'border-box'
            },
            searchIconInside: {
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#a0aec0',
                pointerEvents: 'none'
            },
            itemsListContainer: {
                maxHeight: '400px',
                overflowY: 'auto',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                background: 'white'
            },
            checkboxItem: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 15px',
                borderBottom: '1px solid #f7fafc',
                transition: 'background-color 0.2s ease',
                userSelect: 'none'
            },
            checkboxContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flex: 1
            },
            checkbox: {
                width: '18px',
                height: '18px',
                accentColor: '#4facfe',
                cursor: 'pointer'
            },
            itemLabel: {
                fontSize: '14px',
                fontWeight: '500'
            },
            itemInfo: {
                fontSize: '12px'
            },
            stockLabel: {
                color: '#38a169',
                fontWeight: '500'
            },
            outOfStockLabel: {
                color: '#e53e3e',
                fontWeight: '600'
            },
            selectedItemWithQuantity: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '15px',
                background: '#f0fff4',
                borderRadius: '8px',
                marginBottom: '10px',
                border: '1px solid #9ae6b4'
            },
            selectedItemName: {
                flex: 1
            },
            autocompleteContainer: {
                position: 'relative',
                marginBottom: '15px'
            },
            autocompleteInput: {
                width: '100%',
                padding: '12px 40px 12px 12px',
                borderRadius: '8px',
                border: '2px solid #e2e8f0',
                fontSize: '14px',
                boxSizing: 'border-box'
            },
            searchIcon: {
                position: 'absolute',
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#718096',
                pointerEvents: 'none'
            },
            autocompleteDropdown: {
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                background: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                maxHeight: '200px',
                overflowY: 'auto',
                zIndex: 1000,
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            },
            autocompleteItem: {
                padding: '12px',
                borderBottom: '1px solid #f7fafc',
                cursor: 'pointer',
                fontSize: '14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            },
            selectedItemsContainer: {
                background: 'white',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '10px',
                marginTop: '15px',
                maxHeight: '300px',
                overflowY: 'auto'
            },
            selectedItem: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px',
                background: '#f7fafc',
                borderRadius: '6px',
                marginBottom: '8px',
                fontSize: '14px'
            },
            quantityControls: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            },
            quantityButton: {
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '28px',
                height: '28px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
            },
            quantityDisplay: {
                minWidth: '30px',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '14px'
            },
            saveButton: {
                background: 'linear-gradient(45deg, #48bb78, #38a169)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                padding: '12px 25px',
                fontSize: '14px',
                fontWeight: 'bold',
                width: '100%',
                marginTop: '15px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(72, 187, 120, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
            },
            saveButtonDisabled: {
                background: '#a0aec0',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                padding: '12px 25px',
                fontSize: '14px',
                fontWeight: 'bold',
                width: '100%',
                marginTop: '15px',
                cursor: 'not-allowed',
                transition: 'all 0.3s ease',
                boxShadow: 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
            },
            cancelButton: {
                background: 'linear-gradient(45deg, #f56565, #e53e3e)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                padding: '12px 25px',
                fontSize: '14px',
                fontWeight: 'bold',
                width: '100%',
                marginTop: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(245, 101, 101, 0.3)'
            },
            stockInfo: {
                fontSize: '12px',
                color: '#718096'
            },
            outOfStock: {
                color: '#e53e3e',
                fontWeight: 'bold'
            },
            priceSection: {
                background: '#fff5f5',
                borderRadius: '12px',
                padding: '15px',
                margin: '10px 0',
                border: '2px solid #fbb6ce'
            },
            upsellsSection: {
                background: '#f0f9ff',
                borderRadius: '12px',
                padding: '15px',
                margin: '10px 0',
                border: '2px solid #3b82f6'
            },
            checkboxContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '10px'
            },
            checkboxInput: {
                width: '20px',
                height: '20px',
                accentColor: '#3b82f6',
                cursor: 'pointer'
            },
            checkboxLabel: {
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#1e40af',
                cursor: 'pointer',
                userSelect: 'none'
            }
        };

        return (
            <SideSheet
                isShown={isEditSheetOpen}
                onCloseComplete={this.closeEditSheet}
                containerProps={{
                    display: 'flex',
                    flex: '1',
                    flexDirection: 'column',
                }}
                width={window.innerWidth < 768 ? '100vw' : 400}
            >
                <div style={styles.sideSheetContent}>
                    <div style={styles.sideSheetHeader}>
                        <h2 style={styles.sideSheetTitle}>
                            {editType === 'address' ? 'تعديل العنوان' : 'تعديل المواد المطلوبة'}
                        </h2>
                        <button
                            onClick={this.closeEditSheet}
                            disabled={isUpdatingAddress || isUpdatingItems}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '20px',
                                cursor: (isUpdatingAddress || isUpdatingItems) ? 'not-allowed' : 'pointer',
                                color: (isUpdatingAddress || isUpdatingItems) ? '#a0aec0' : '#666',
                                padding: '5px',
                                opacity: (isUpdatingAddress || isUpdatingItems) ? 0.5 : 1
                            }}
                        >
                            <FaTimes />
                        </button>
                    </div>

                    {editType === 'address' && (
                        <div>
                            <div style={styles.formSection}>
                                <div style={styles.formSectionTitle}>
                                    <FaMapMarkerAlt />
                                    معلومات العنوان
                                </div>

                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                                        المحافظة
                                    </label>
                                    <select
                                        value={editData.government}
                                        onChange={(e) => this.updateEditData('government', e.target.value)}
                                        style={styles.select}
                                    >
                                        <option value="">اختر المحافظة</option>
                                        {governments.map(gov => (
                                            <option key={gov} value={gov}>{gov}</option>
                                        ))}
                                    </select>
                                </div>

                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                                        المنطقة
                                    </label>
                                    <input
                                        type="text"
                                        value={editData.city}
                                        onChange={(e) => this.updateEditData('city', e.target.value)}
                                        placeholder="أدخل اسم المنطقة"
                                        style={styles.input}
                                    />
                                </div>
                            </div>

                            <button
                                style={isUpdatingAddress ? styles.saveButtonDisabled : styles.saveButton}
                                onClick={this.saveEditChanges}
                                disabled={!editData.government || !editData.city || isUpdatingAddress}
                            >
                                {isUpdatingAddress ? (
                                    <>
                                        <Spinner size={16} />
                                        جاري التحديث...
                                    </>
                                ) : (
                                    'حفظ التغييرات'
                                )}
                            </button>
                            <button
                                style={styles.cancelButton}
                                onClick={this.closeEditSheet}
                                disabled={isUpdatingAddress}
                            >
                                {isUpdatingAddress ? 'جاري التحديث...' : 'إلغاء'}
                            </button>
                        </div>
                    )}

                    {editType === 'items' && (
                        <div>
                            <div style={styles.formSection}>
                                <div style={styles.formSectionTitle}>
                                    <FaBoxes />
                                    اختر المنتجات
                                </div>

                                {/* Search Box */}
                                <div style={styles.searchContainer}>
                                    <input
                                        type="text"
                                        value={itemSearchValue}
                                        onChange={(e) => this.handleItemSearch(e.target.value)}
                                        placeholder="Search..."
                                        style={styles.searchInput}
                                    />
                                    <FaSearch style={styles.searchIconInside} />
                                </div>

                                {/* Items List with Checkboxes */}
                                <div style={styles.itemsListContainer}>
                                    {(itemSearchValue ? filteredItems : this.state.availableItems).map(item => {
                                        const isSelected = selectedItemsForEdit[item.id] > 0;
                                        const isNegativeStock = item.count < 0;

                                        return (
                                            <div
                                                key={item.id}
                                                style={{
                                                    ...styles.checkboxItem,
                                                    backgroundColor: isNegativeStock ? '#fee' : 'transparent',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => this.toggleItemSelection(item)}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#f7fafc';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = isNegativeStock ? '#fee' : 'transparent';
                                                }}
                                            >
                                                <div style={styles.checkboxContainer}>
                                                    <input
                                                        type="checkbox"
                                                        checked={isSelected}
                                                        onChange={() => { }}
                                                        style={styles.checkbox}
                                                    />
                                                    <span style={{
                                                        ...styles.itemLabel,
                                                        color: isNegativeStock ? '#c53030' : '#2d3748'
                                                    }}>
                                                        {item.label}
                                                    </span>
                                                </div>
                                                <div style={styles.itemInfo}>
                                                    {isNegativeStock ? (
                                                        <span style={{ ...styles.outOfStockLabel, color: '#c53030' }}>
                                                            سالب: {item.count}
                                                        </span>
                                                    ) : item.count === 0 ? (
                                                        <span style={styles.outOfStockLabel}>نفد المخزون</span>
                                                    ) : (
                                                        <span style={styles.stockLabel}>متوفر: {item.count}</span>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Selected Items with Quantity Controls */}
                            {Object.keys(selectedItemsForEdit).length > 0 && (
                                <div style={styles.formSection}>
                                    <div style={styles.formSectionTitle}>
                                        <FaCheckCircle />
                                        المواد المختارة والكميات
                                    </div>

                                    <div style={styles.selectedItemsContainer}>
                                        {Object.entries(selectedItemsForEdit).map(([itemId, quantity]) => {
                                            // First try to find by ID, then by name
                                            let item = this.findItemByIdOrName(itemId);

                                            // If not found in available items, create a placeholder from order data
                                            if (!item && this.state.order && this.state.order.ordersFormItems) {
                                                const orderItem = this.state.order.ordersFormItems.find(oi =>
                                                    (oi.components.id && oi.components.id.toString() === itemId.toString()) ||
                                                    oi.components.name === itemId
                                                );
                                                if (orderItem) {
                                                    item = {
                                                        id: itemId,
                                                        label: orderItem.components.name,
                                                        count: 999 // Assume high stock for existing items
                                                    };
                                                }
                                            }

                                            if (!item || quantity <= 0) return null;

                                            // Check if this is an original item from the order
                                            const isOriginalItem = this.state.order && this.state.order.ordersFormItems &&
                                                this.state.order.ordersFormItems.some(oi =>
                                                    (oi.components.id && oi.components.id.toString() === itemId.toString()) ||
                                                    oi.components.name === itemId
                                                );

                                            return (
                                                <div key={itemId} style={{
                                                    ...styles.selectedItemWithQuantity,
                                                    background: isOriginalItem ? '#fff3cd' : '#f0fff4',
                                                    border: isOriginalItem ? '1px solid #ffc107' : '1px solid #9ae6b4'
                                                }}>
                                                    <div style={styles.selectedItemName}>
                                                        <div style={{
                                                            fontWeight: 'bold',
                                                            marginBottom: '4px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}>
                                                            {item.label}
                                                            {isOriginalItem && (
                                                                <span style={{
                                                                    background: '#ff9800',
                                                                    color: 'white',
                                                                    fontSize: '10px',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '10px',
                                                                    fontWeight: 'bold'
                                                                }}>
                                                                    موجود في الطلب
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div style={styles.stockInfo}>
                                                            {item.count === 999 ? 'مادة من الطلب الأصلي' : `متوفر: ${item.count}`}
                                                        </div>
                                                    </div>

                                                    <div style={styles.quantityControls}>
                                                        <button
                                                            style={{
                                                                ...styles.quantityButton,
                                                                opacity: quantity <= 1 ? 0.5 : 1
                                                            }}
                                                            onClick={() => this.updateItemQuantity(itemId, quantity - 1)}
                                                            disabled={quantity <= 1}
                                                        >
                                                            <FaMinus />
                                                        </button>

                                                        <div style={styles.quantityDisplay}>
                                                            {quantity}
                                                        </div>

                                                        <button
                                                            style={{
                                                                ...styles.quantityButton,
                                                                opacity: quantity >= item.count && item.count !== 999 ? 0.5 : 1
                                                            }}
                                                            onClick={() => this.updateItemQuantity(itemId, quantity + 1)}
                                                            disabled={quantity >= item.count && item.count !== 999}
                                                        >
                                                            <FaPlus />
                                                        </button>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {/* Price Section - After Selected Items */}
                            <div style={styles.priceSection}>
                                <div style={styles.formSectionTitle}>
                                    <FaDollarSign />
                                    السعر الإجمالي
                                </div>

                                <div style={{ marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: 'bold' }}>
                                        السعر (دينار عراقي) *
                                    </label>
                                    <input
                                        type="number"
                                        value={editData.price || ''}
                                        onChange={(e) => this.updateEditData('price', e.target.value ? parseInt(e.target.value) : '')}
                                        placeholder="أدخل السعر الإجمالي"
                                        style={{
                                            ...styles.numberInput,
                                            border: !editData.price ? '2px solid #f56565' : '2px solid #e2e8f0'
                                        }}
                                        min="0"
                                        step="1000"
                                    />
                                    {!editData.price && (
                                        <div style={{
                                            color: '#e53e3e',
                                            fontSize: '12px',
                                            marginTop: '5px',
                                            fontWeight: 'bold'
                                        }}>
                                            السعر مطلوب
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Upsells Section - تحت قسم السعر */}
                            <div style={styles.upsellsSection}>
                                <div style={styles.formSectionTitle}>
                                    <FaCheckCircle />
                                    نوع البيع
                                    {this.state.order && this.state.order.is_upsells == 1 && (
                                        <span style={{
                                            background: '#10b981',
                                            color: 'white',
                                            fontSize: '10px',
                                            padding: '2px 6px',
                                            borderRadius: '8px',
                                            marginRight: '8px'
                                        }}>
                                            مفعّل حالياً
                                        </span>
                                    )}
                                </div>

                                <div style={styles.checkboxContainer}>
                                    <input
                                        type="checkbox"
                                        id="upsells-checkbox"
                                        checked={editData.is_upsells}
                                        onChange={(e) => this.updateEditData('is_upsells', e.target.checked)}
                                        style={styles.checkboxInput}
                                    />
                                    <label
                                        htmlFor="upsells-checkbox"
                                        style={styles.checkboxLabel}
                                        onClick={() => this.updateEditData('is_upsells', !editData.is_upsells)}
                                    >
                                        مبيعات أعلى (Upsells)
                                    </label>
                                </div>

                                <div style={{
                                    fontSize: '12px',
                                    color: '#64748b',
                                    marginTop: '8px',
                                    lineHeight: '1.4'
                                }}>
                                    ✓ فعّل هذا الخيار إذا تم بيع منتجات إضافية أو ترقية الطلب الأصلي
                                    {this.state.order && this.state.order.is_upsells == 1 && (
                                        <div style={{
                                            color: '#10b981',
                                            fontWeight: 'bold',
                                            marginTop: '4px'
                                        }}>
                                            📈 هذا الطلب مصنف حالياً كمبيعات أعلى
                                        </div>
                                    )}
                                </div>
                            </div>

                            <button
                                style={isUpdatingItems ? styles.saveButtonDisabled : styles.saveButton}
                                onClick={this.saveEditChanges}
                                disabled={Object.keys(selectedItemsForEdit).length === 0 || isUpdatingItems || !editData.price}
                            >
                                {isUpdatingItems ? (
                                    <>
                                        <Spinner size={16} />
                                        جاري التحديث...
                                    </>
                                ) : (
                                    <>
                                        <FaCheckCircle />
                                        حفظ التغييرات
                                        {editData.is_upsells && (
                                            <span style={{
                                                background: '#3b82f6',
                                                color: 'white',
                                                fontSize: '10px',
                                                padding: '2px 6px',
                                                borderRadius: '8px',
                                                marginLeft: '5px'
                                            }}>
                                                مبيعات أعلى
                                            </span>
                                        )}
                                    </>
                                )}
                            </button>
                            <button
                                style={styles.cancelButton}
                                onClick={this.closeEditSheet}
                                disabled={isUpdatingItems}
                            >
                                {isUpdatingItems ? 'جاري التحديث...' : 'إلغاء'}
                            </button>
                        </div>
                    )}
                </div>
            </SideSheet>
        );
    }

    render() {
        const { order, loading } = this.state;

        const styles = {
            container: {
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                minHeight: '100vh',
                padding: '10px',
                fontFamily: 'Cairo, Arial, sans-serif'
            },
            header: {
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                padding: '15px',
                marginBottom: '15px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                border: '1px solid rgba(255, 255, 255, 0.2)'
            },
            headerContent: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: '10px'
            },
            backButton: {
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '45px',
                height: '45px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px',
                boxShadow: '0 4px 15px rgba(79, 172, 254, 0.4)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
            },
            title: {
                color: '#2d3748',
                fontSize: '20px',
                fontWeight: 'bold',
                textAlign: 'center',
                flex: 1,
                margin: '0 10px'
            },
            actionButton: {
                background: 'linear-gradient(45deg, #48bb78, #38a169)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                padding: '8px 15px',
                fontSize: '12px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 4px 15px rgba(72, 187, 120, 0.3)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
            },
            editButton: {
                background: 'linear-gradient(45deg, #ff9800, #f57c00)',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                padding: '8px 15px',
                fontSize: '12px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
            },
            orderCard: {
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                borderRadius: '20px',
                boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                overflow: 'hidden',
                marginBottom: '15px'
            },
            orderHeader: {
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                color: 'white',
                padding: '20px',
                textAlign: 'center',
                position: 'relative'
            },
            orderNumber: {
                fontSize: '24px',
                fontWeight: 'bold',
                marginBottom: '6px'
            },
            orderDate: {
                fontSize: '14px',
                opacity: 0.9
            },
            statusBadge: {
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'rgba(255, 255, 255, 0.2)',
                padding: '6px 12px',
                borderRadius: '15px',
                fontSize: '12px',
                fontWeight: 'bold',
                backdropFilter: 'blur(10px)',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            },
            confirmBadge: {
                position: 'absolute',
                top: '10px',
                left: '10px',
                background: '#ff9800',
                color: 'white',
                padding: '6px 12px',
                borderRadius: '15px',
                fontSize: '12px',
                fontWeight: 'bold',
                boxShadow: '0 4px 15px rgba(255, 152, 0, 0.4)',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            },
            orderBody: {
                padding: '20px'
            },
            section: {
                background: '#f8fafc',
                borderRadius: '15px',
                padding: '15px',
                margin: '15px 0',
                border: '1px solid #e2e8f0',
                position: 'relative'
            },
            sectionWithEdit: {
                background: '#f8fafc',
                borderRadius: '15px',
                padding: '15px',
                margin: '15px 0',
                border: '1px solid #e2e8f0',
                position: 'relative'
            },
            sectionHeader: {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '15px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#2d3748'
            },
            sectionHeaderWithEdit: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '15px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#2d3748',
                flexWrap: 'wrap',
                gap: '10px'
            },
            sectionIcon: {
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                color: 'white',
                borderRadius: '50%',
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px'
            },
            editIconButton: {
                background: 'linear-gradient(45deg, #ff9800, #f57c00)',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 3px 10px rgba(255, 152, 0, 0.3)'
            },
            contactButtons: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
                margin: '10px 0'
            },
            contactButton: {
                padding: '12px',
                borderRadius: '12px',
                border: 'none',
                fontWeight: 'bold',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
            },
            phoneButton: {
                background: 'linear-gradient(45deg, #4299e1, #3182ce)',
                color: 'white',
                boxShadow: '0 6px 20px rgba(66, 153, 225, 0.3)'
            },
            whatsappButton: {
                background: 'linear-gradient(45deg, #48bb78, #38a169)',
                color: 'white',
                boxShadow: '0 6px 20px rgba(72, 187, 120, 0.3)'
            },
            infoGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '10px'
            },
            infoCard: {
                background: 'white',
                padding: '15px',
                borderRadius: '12px',
                textAlign: 'center',
                border: '1px solid #e2e8f0',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s ease'
            },
            infoLabel: {
                fontSize: '12px',
                color: '#718096',
                marginBottom: '6px',
                fontWeight: '500'
            },
            infoValue: {
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#2d3748'
            },
            itemCard: {
                background: 'white',
                padding: '12px',
                borderRadius: '10px',
                margin: '8px 0',
                border: '1px solid #e2e8f0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s ease'
            },
            itemName: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#2d3748'
            },
            itemCount: {
                background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                color: 'white',
                padding: '4px 10px',
                borderRadius: '15px',
                fontSize: '12px',
                fontWeight: 'bold'
            },
            actionButtonsContainer: {
                background: '#f8fafc',
                padding: '20px',
                borderRadius: '0 0 20px 20px',
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                flexWrap: 'wrap'
            },
            primaryActionButton: {
                background: 'linear-gradient(45deg, #48bb78, #38a169)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                padding: '12px 20px',
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 6px 20px rgba(72, 187, 120, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: '1',
                minWidth: '120px',
                justifyContent: 'center'
            },
            warningActionButton: {
                background: 'linear-gradient(45deg, #ff9800, #f57c00)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                padding: '12px 20px',
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: '1',
                minWidth: '120px',
                justifyContent: 'center'
            },
            dangerActionButton: {
                background: 'linear-gradient(45deg, #f56565, #e53e3e)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                padding: '12px 20px',
                fontSize: '14px',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 6px 20px rgba(245, 101, 101, 0.3)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: '1',
                minWidth: '120px',
                justifyContent: 'center'
            },
            loadingContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '200px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '20px'
            },
            alertBox: {
                background: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '12px',
                padding: '15px',
                margin: '15px 0',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
            },
            alertIcon: {
                color: '#ff9800',
                fontSize: '20px'
            },
            alertText: {
                color: '#856404',
                fontWeight: 'bold',
                fontSize: '14px'
            }
        };

        const mediaQueries = `
            @media (max-width: 768px) {
                .contact-buttons {
                    grid-template-columns: 1fr !important;
                }
                .info-grid {
                    grid-template-columns: 1fr !important;
                }
                .header-content {
                    flex-direction: column;
                    text-align: center;
                }
                .action-buttons {
                    flex-direction: column;
                    align-items: stretch;
                }
                .section-header-edit {
                    flex-direction: column;
                    gap: 8px;
                    align-items: flex-start;
                }
                .header-buttons {
                    flex-direction: column;
                    gap: 8px;
                    width: 100%;
                }
                .order-number {
                    font-size: 20px !important;
                }
                .section-title {
                    font-size: 14px !important;
                }
                .primary-action-button,
                .warning-action-button,
                .danger-action-button {
                    min-width: 100% !important;
                    margin-bottom: 8px;
                }
            }
        `;

        if (loading) {
            return (
                <div style={styles.container}>
                    <style>{mediaQueries}</style>
                    <div style={styles.loadingContainer}>
                        <Spinner size={48} />
                    </div>
                </div>
            );
        }

        if (!order) {
            return (
                <div style={styles.container}>
                    <style>{mediaQueries}</style>
                    <div style={styles.header}>
                        <div style={styles.headerContent}>
                            <Link to='/confirm-orders'>
                                <button style={styles.backButton}>
                                    <FaArrowCircleLeft />
                                </button>
                            </Link>
                            <h1 style={styles.title}>الطلب  </h1>
                        </div>
                    </div>
                </div>
            );
        }

        // التحقق من إمكانية التعديل
        const canEdit = this.canEdit();

        return (
            <div style={styles.container}>
                <style>{mediaQueries}</style>
                <Context.Consumer>
                    {ctx => (
                        <div>
                            {/* Header */}
                            <div style={styles.header}>
                                <div style={styles.headerContent} className="header-content">
                                   
                                        <button onClick={() => window.history.back()} style={styles.backButton}>
                                            <FaArrowCircleLeft />
                                        </button>
                                  
                                    <h1 style={styles.title}>تعديل الطلب</h1>
                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }} className="header-buttons">

                                    </div>
                                </div>
                            </div>

                            {/* Alert Box - يظهر فقط إذا كان يمكن التعديل */}
                            {canEdit && (
                                <div style={styles.alertBox}>
                                    <FaExclamationTriangle style={styles.alertIcon} />
                                    <div style={styles.alertText}>
                                        هذا الطلب يحتاج إلى تأكيد من قبلك
                                    </div>
                                </div>
                            )}

                            {/* Order Card */}
                            <div style={styles.orderCard}>
                                {/* Order Header */}
                                <div style={styles.orderHeader}>
                                    <div style={styles.orderNumber} className="order-number">
                                        رقم الوصل: {order.id}
                                    </div>
                                    <div style={styles.orderDate}>
                                        {moment(order.createdAt).tz("Asia/Baghdad").format('DD/MM/YYYY - LT')}
                                    </div>
                                </div>

                                <div style={styles.orderBody}>
                                    {/* Contact Section */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionHeader}>
                                            <div style={styles.sectionIcon}>
                                                <FaPhone />
                                            </div>
                                            معلومات التواصل
                                        </div>

                                        <div style={styles.contactButtons} className="contact-buttons">
                                            <button
                                                style={{ ...styles.contactButton, ...styles.phoneButton }}
                                                onClick={() => {
                                                    this.click_log(order.id, 'phone');
                                                    window.location.href = `tel:${order.phone}`;
                                                }}
                                            >
                                                <FaPhone />
                                                {order.phone}
                                            </button>
                                            <button
                                                style={{ ...styles.contactButton, ...styles.whatsappButton }}
                                                onClick={() => {
                                                    this.click_log(order.id, 'whatssap');
                                                    setTimeout(() => {
                                                        window.location.replace(`https://api.whatsapp.com/send?phone=964${order.phone.slice(1)}`);
                                                    }, 500);
                                                }}
                                            >
                                                <IoLogoWhatsapp />
                                                واتساب
                                            </button>
                                        </div>
                                    </div>

                                    {/* Customer Info */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionHeader}>
                                            <div style={styles.sectionIcon}>
                                                <FaUser />
                                            </div>
                                            معلومات الزبون
                                        </div>

                                        <div style={styles.infoGrid} className="info-grid">
                                            <div style={styles.infoCard}>
                                                <div style={styles.infoLabel}>اسم الزبون</div>
                                                <div style={styles.infoValue}>{order.name}</div>
                                            </div>
                                            <div style={styles.infoCard}>
                                                <div style={styles.infoLabel}>اسم البيج</div>
                                                <div style={styles.infoValue}>{order.page_name}</div>
                                            </div>
                                            <div style={styles.infoCard}>
                                                <div style={styles.infoLabel}>السعر الكلي</div>
                                                <div style={styles.infoValue}>{order.price} </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Address - التحقق من إمكانية التعديل */}
                                    <div style={canEdit ? styles.sectionWithEdit : styles.section}>
                                        <div style={canEdit ? styles.sectionHeaderWithEdit : styles.sectionHeader} className="section-header-edit">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <div style={styles.sectionIcon}>
                                                    <FaMapMarkerAlt />
                                                </div>
                                                <span className="section-title">العنوان</span>
                                            </div>
                                            {canEdit && (
                                                <button
                                                    style={styles.editIconButton}
                                                    onClick={() => this.openEditSheet('address')}
                                                    title="تعديل العنوان"
                                                >
                                                    <FaEdit />
                                                </button>
                                            )}
                                        </div>

                                        <div style={styles.infoCard}>
                                            <div style={styles.infoValue}>
                                                {order.government} / {order.city}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items - التحقق من إمكانية التعديل */}
                                    <div style={canEdit ? styles.sectionWithEdit : styles.section}>
                                        <div style={canEdit ? styles.sectionHeaderWithEdit : styles.sectionHeader} className="section-header-edit">
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <div style={styles.sectionIcon}>
                                                    <FaBoxes />
                                                </div>
                                                <span className="section-title">المواد المطلوبة</span>
                                            </div>
                                            {canEdit && (
                                                <button
                                                    style={styles.editIconButton}
                                                    onClick={() => this.openEditSheet('items')}
                                                    title="تعديل المواد"
                                                >
                                                    <FaEdit />
                                                </button>
                                            )}
                                        </div>

                                        {order.ordersFormItems && order.ordersFormItems.map((item, i) => (
                                            <div key={i} style={styles.itemCard}>
                                                <div style={styles.itemName}>
                                                    {item.components.name}
                                                </div>
                                                <div style={styles.itemCount}>
                                                    العدد: {item.count}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Dates */}
                                    <div style={styles.section}>
                                        <div style={styles.sectionHeader}>
                                            <div style={styles.sectionIcon}>
                                                <FaClock />
                                            </div>
                                            التواريخ المهمة
                                        </div>

                                        <div style={styles.infoGrid} className="info-grid">
                                            <div style={styles.infoCard}>
                                                <div style={styles.infoLabel}>وقت الحجز</div>
                                                <div style={styles.infoValue}>
                                                    {moment(order.createdAt).tz("Asia/Baghdad").format('DD/MM/YYYY LT')}
                                                </div>
                                            </div>
                                            <div style={styles.infoCard}>
                                                <div style={styles.infoLabel}>آخر تحديث</div>
                                                <div style={styles.infoValue}>
                                                    {moment(order.updatedAt).tz("Asia/Baghdad").format('DD/MM/YYYY LT')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Action Buttons - يظهر فقط إذا كان يمكن التعديل */}
                                {canEdit && (
                                    <div style={styles.actionButtonsContainer} className="action-buttons">
                                        {/* Confirm Button */}
                                        <Component initialState={{ isShown: false, notes: "" }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        onCloseComplete={() => setState({ isShown: false })}
                                                        confirmLabel="تأكيد الطلب"
                                                        intent="success"
                                                        hasFooter={true}
                                                        title={"تأكيد الطلب"}
                                                        onConfirm={() => {
                                                            this.confirmOrder(order.id, order.name, state.notes);
                                                            setState({ isShown: false, notes: "" });
                                                        }}
                                                    >
                                                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                                                            <div style={styles.section}>
                                                                <div style={styles.infoGrid}>
                                                                    <div style={styles.infoCard}>
                                                                        <div style={styles.infoLabel}>رقم الوصل</div>
                                                                        <div style={styles.infoValue}>{order.id}</div>
                                                                    </div>
                                                                    <div style={styles.infoCard}>
                                                                        <div style={styles.infoLabel}>اسم الزبون</div>
                                                                        <div style={styles.infoValue}>{order.name}</div>
                                                                    </div>
                                                                    <div style={styles.infoCard}>
                                                                        <div style={styles.infoLabel}>العنوان</div>
                                                                        <div style={styles.infoValue}>{order.government + " / " + order.city}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Label>ملاحظات</Label>
                                                            <Textarea
                                                                value={state.notes}
                                                                placeholder="الملاحظات ان وجدت"
                                                                onChange={(e) => setState({ notes: e.target.value })}
                                                            />
                                                        </div>
                                                    </Dialog>
                                                    <button
                                                        style={styles.primaryActionButton}
                                                        className="primary-action-button"
                                                        onClick={() => setState({ isShown: true })}
                                                    >
                                                        <FcApproval />
                                                        تأكيد الطلب
                                                    </button>
                                                </Pane>
                                            )}
                                        </Component>

                                        {/* No Answer Button */}
                                        <Component initialState={{ isShown: false }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        onCloseComplete={() => setState({ isShown: false })}
                                                        confirmLabel="جعله لايرد"
                                                        intent="warning"
                                                        hasFooter={true}
                                                        title={"تحديد الطلب لايرد"}
                                                        onConfirm={() => {
                                                            this.setNoAnswer(order.id, order.name);
                                                            setState({ isShown: false });
                                                        }}
                                                    >
                                                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                                                            <div style={styles.section}>
                                                                <div style={{
                                                                    background: '#fff3cd',
                                                                    border: '1px solid #ffc107',
                                                                    borderRadius: '12px',
                                                                    padding: '15px',
                                                                    marginBottom: '15px'
                                                                }}>
                                                                    <strong>تنبيه:</strong> سيتم تحويل الطلب رقم {order.id} إلى قائمة "لا يرد"
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Dialog>
                                                    <button
                                                        style={styles.warningActionButton}
                                                        className="warning-action-button"
                                                        onClick={() => setState({ isShown: true })}
                                                    >
                                                        <FcMissedCall />
                                                        لا يرد
                                                    </button>
                                                </Pane>
                                            )}
                                        </Component>

                                        {/* Cancel Button */}
                                        <Component initialState={{ isShown: false, notes: "" }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        title="الغاء الطلب"
                                                        intent="danger"
                                                        onCloseComplete={() => setState({ isShown: false })}
                                                        confirmLabel="تاكيد الالغاء"
                                                        cancelLabel='الغاء'
                                                        onConfirm={() => {
                                                            if (!state.notes) {
                                                                window.alert('ادخل سبب الالغاء');
                                                                return -1;
                                                            } else {
                                                                this.deleteOrder(order.id, order.name, state.notes);
                                                                setState({ isShown: false, notes: '' });
                                                            }
                                                        }}
                                                    >
                                                        <div style={{ direction: 'rtl', textAlign: 'right' }}>
                                                            <div style={styles.section}>
                                                                <div style={styles.sectionHeader}>
                                                                    <div style={styles.sectionIcon}>
                                                                        <FcCancel />
                                                                    </div>
                                                                    تأكيد الالغاء
                                                                </div>
                                                                <div style={{
                                                                    background: '#fed7d7',
                                                                    border: '1px solid #fc8181',
                                                                    borderRadius: '12px',
                                                                    padding: '15px',
                                                                    marginBottom: '15px'
                                                                }}>
                                                                    <strong>تحذير:</strong> سيتم الغاء الطلب رقم {order.id} نهائياً
                                                                </div>
                                                            </div>
                                                            <Label style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px', display: 'block' }}>
                                                                سبب الالغاء *
                                                            </Label>
                                                            <Textarea
                                                                value={state.notes}
                                                                placeholder="اكتب سبب الالغاء..."
                                                                style={{
                                                                    minHeight: '100px',
                                                                    border: '2px solid #e2e8f0',
                                                                    borderRadius: '12px'
                                                                }}
                                                                onChange={(e) => setState({ notes: e.target.value })}
                                                            />
                                                        </div>
                                                    </Dialog>
                                                    <button
                                                        style={styles.dangerActionButton}
                                                        className="danger-action-button"
                                                        onClick={() => setState({ isShown: true })}
                                                    >
                                                        <FcCancel />
                                                        الغاء الطلب
                                                    </button>
                                                </Pane>
                                            )}
                                        </Component>
                                    </div>
                                )}
                            </div>

                            {/* Edit Side Sheet - يظهر فقط إذا كان يمكن التعديل */}
                            {canEdit && this.renderEditSideSheet()}
                        </div>
                    )}
                </Context.Consumer>
            </div>
        );
    }
}

export default SingleConfirmOrder;